import { root } from './events';

export const events = {
  ...root,
};
